<div class="sort-container">
  <div class="row space-between">
    <div class="col-10" style="font-size: 12px; font-weight: bold">Sorting</div>
    <div class="col-2">
      <div class="clear-button" (click)="clearSortData()"><span>Clear Conditions<mat-icon style="font-size: 18px">playlist_remove</mat-icon></span></div>
    </div>
  </div>
  @for(group of sortGroups; track $index; let i = $index){
    <div class="row">
      <div class="col-md-3">
        <div style="display: flex; align-items: center; gap: 8px;font-weight: bold">
        {{i + 1}}
        <mat-form-field class="dense-field" subscriptSizing="dynamic">
          <mat-select [formControl]="pipeFilterService.getControl(group, 'field')" (selectionChange)="onSelectionChange($event, group)" [compareWith]="compareObjects">
            @for(field of (pipelineService.sortFilters$ | async); track field.id){
              <mat-option [value]="field">{{field.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        </div>
      </div>
      @if(pipeFilterService.checkSelected(group, 'field') && !pipeFilterService.isJsonFormatField(group)){
        <div class="col-md-3">
          <mat-form-field class="dense-field" subscriptSizing="dynamic">
            <mat-select [formControl]="pipeFilterService.getControl(group, 'value')" [compareWith]="compareObjects">
              @for(dir of pipeFilterService.sortSelection; track $index){
                <mat-option [value]="dir">{{dir.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="delete-condition-row" (click)="removeSortCondition(group)"><mat-icon>delete</mat-icon></div>
      }
<!--    </div>-->
<!--    HAS JSON-->
    @if(pipeFilterService.checkSelected(group, 'field') && pipeFilterService.isJsonFormatField(group)){
          @for(form of pipeFilterService.getChildFormArray(group).controls; track $index; let childIdx = $index){
              <div class="col-md-3">
                @if(!pipeFilterService.isSpecialLookup(group)){
                <mat-form-field class="dense-field" subscriptSizing="dynamic">
                  <mat-select [formControl]="pipeFilterService.getControl(form, 'field')" (selectionChange)="onSelectionChange($event, form)" [compareWith]="compareObjects">
<!--                    @if(group.value.children.length <= 1){-->
                      @for(option of pipeFilterService.getChildrenSelection(group); track option.id){
                        @if(childIdx === 0 && option.is_sortable && option.format!=='id' && option.format!=='select' && option.sort_type=='value'){
                          <mat-option [value]="option">{{option.name}}</mat-option>
                        }
                        @if(childIdx > 0 && option.is_sortable && option.format === 'select' && option.sort_type=='filter'){
                          <mat-option [value]="option">{{option.name}}</mat-option>
                        }
                      }
<!--                    }-->
<!--                    @if(group.value.children.length > 1){-->
<!--                      @for(option of pipeFilterService.getChildrenSelection(group); track option.id){-->
<!--                        @if(option.is_sortable && option.format==='select' && option.sort_type=='filter'){-->
<!--                          <mat-option [value]="option">{{option.name}}</mat-option>-->
<!--                        }-->
<!--                      }-->
<!--                    }-->
                  </mat-select>
                </mat-form-field>
                }
                @if(pipeFilterService.isSpecialLookup(group)){
                  <mat-form-field class="dense-field" subscriptSizing="dynamic">
                    <mat-select [formControl]="pipeFilterService.getControl(form, 'field')" [compareWith]="compareObjects">
                      @for(option of (pipelineService.modelSelections$ | async) && pipelineService.getModelSelections(group) ; track option.id){
                        <mat-option [value]="option">{{option.name}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </div>
              @if(pipeFilterService.checkSelected(form, 'field')){
                <div class="col-md-3">
                  <mat-form-field class="dense-field" subscriptSizing="dynamic">
                    <mat-select [formControl]="pipeFilterService.getControl(form, 'value')" [compareWith]="compareObjects">
                      @if(form.value.field.format==='select'){
                        @for(option of (pipelineService.sortingSelections$ | async) && pipelineService.getSortSelections(form); track $index){
                          <mat-option [value]="option">{{option['name']}}</mat-option>
                        }
                      }
                      @if(form.value.field.format!=='select'){
                        @for(option of pipeFilterService.sortSelection; track $index){
                          <mat-option [value]="option">{{option['name']}}</mat-option>
                        }
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            <div class="delete-condition-row" (click)="removeSortCondition(group)"><mat-icon>delete</mat-icon></div>
          }
          @if(!pipeFilterService.isSpecialLookup(group)){
            <div class="row justify-flex-end">
              <div class="col-md-10">
                <div class="flat-transparent-button" (click)="addSubSortParameters(group)">+ Add {{pipeFilterService.getControl(group, 'field')?.value?.name}} Sort Parameters</div>
              </div>
            </div>
          }
    }
    </div>
  }
  <div class="row">
      <div class="flat-transparent-button" (click)="addSortParameters()">+ Add Sort Parameters</div>
  </div>
</div>
